import { ParagraphItem } from '../Card';
import React from 'react';

import { ParagraphItemsFragment } from '../../generated/graphql';
import { paragraphItemRoute } from '../../helpers/routes';
import { ItemProps } from './common';
import { PageItemLink } from '../PageItemLink';

const Paragraph: React.FC<ItemProps> = ({ item, page, className, dragProps, preview }) => {
  const { id, textContent } = item as ParagraphItemsFragment;

  return (
    <PageItemLink
      to={paragraphItemRoute(page.id, id, preview)}
      page={page}
      pageItem={item}
      data-testid={`paragraph-item-${id}`}
    >
      <ParagraphItem text={textContent} className={className} {...dragProps} />
    </PageItemLink>
  );
};

export default Paragraph;
